module.exports = __webpack_public_path__ + "static/media/maximize.7ab4d398.svg";